import React from "react";

const ThemedIcon = ({ src, width = 24, height = 24, alt = "" }) => {
    return (
        <img
            src={src}
            alt={alt}
            style={{ width, height }}
            className="grayscale brightness-0 dark:invert"
        />
    );
};

export default ThemedIcon;
